import { useContext } from "react";
import { AppPreferencesContext } from "./AppPreferencesContext";

const useRemediationItemsSplit = (): boolean => {
  const { openSeemplicityFindings } = useContext(AppPreferencesContext);

  return openSeemplicityFindings === true;
};

export default useRemediationItemsSplit;
